import React, { useEffect, useState,useRef } from 'react';
import { Table, Pagination, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../CommonDataTable/CommonDataTable.css';
import RightPageIcon from './../../../assets/svg_main/chevron-right-black.svg';
import LeftPageIcon from './../../../assets/svg_main/chevron-left-black.svg';
import { BsArrowDown, BsArrowUp } from 'react-icons/bs';
import RowsPerPageDropdown from '../RowsPerPageDropdown';
import { useLocation, useNavigate } from 'react-router-dom';
import VillagesMapped from '@pages/GeoNonGeo/components/VillagesMapped';
import VillagesDataModal from '@pages/GeoNonGeo/components/VillagesMapped/VillagesDataModal';
import MappedModal from '../MappedModal';
import { MAPPED_DETAIL, MAPPED_VALUE } from '@constants/index';
import axios from '../../../utils/axiosExt';
import endpoints from '@config/endpoints';
import { useDispatch } from 'react-redux';
import {
  setBlockByHealthBlockId, setULBByHealthBlockId, setSubDistrictByHealthBlockId, setVillageByHealthBlockId, setWardByHealthBlockId,
  setSubDistrictByDistrict,
  setBlockByDistrict,
  setUlbByState
} from '@store/actions/healthBlockActions';
import { setHealthBlockById, setVillagesByBlockId, setWardsByUlbId } from "@store/actions/zoneDetailsActions";
// import { WithPermission } from './../../components/Auth/withPermission';
// import { usePermission } from './../../services/usePermission';
import Auth from '../../../utils/auth';
import CheckboxComponent from '@components/common/CheckBox';
import Button from '../Button';
import { errorLogger } from '@utils/applicationLogUtils';

interface columnheaderType {
  name: string;
  key: string;
  sortable: boolean;
  width?: number;
  showDetails?: string
  gridView?:boolean,
  type?: string;
  allowWrap?:boolean;
  contentStyle?:React.CSSProperties;
}

interface DataTableProps {
  data: any[];
  itemsPerPage: number[];
  searchTerm: any;
  height?: string;
  columnHeader: columnheaderType[];
  pagination?: boolean;
  gridFor: string;
  toolTipPosition?: any;
  selectedRows?: any[];
  handleCheckboxChange?: (value: any, isChecked: boolean) => void;
  onPageChange?: (pageData: any[], pageNumber: number, itemsPerPage: number) => Promise<void>;
}

const DataTable: React.FC<DataTableProps> = ({
  data,
  itemsPerPage,
  searchTerm,
  height = '100%',
  columnHeader,
  pagination = true,
  gridFor,
  toolTipPosition,
  handleCheckboxChange,
  selectedRows=[],
  onPageChange
}: DataTableProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sortKey, setSortKey] = useState<string>('');
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');
  const { pathname } = useLocation();
  //const rowsPerPageDropdown=[10,20,30,40,50];
  const [selectedRow, setSelectedRow] = useState<number>(itemsPerPage[0]);
  const [mappedModal, setShowMappedModel] = useState<boolean>(false);
  const [currentColumn, setCurrentColumn] = useState<number>(0);
  const [mappedOf, setMappedOf] = useState<string>('districts');
  const handleSelectedRow = async (value: number) => {
    setSelectedRow(value);
    await handlePaginationChange(1, value);
  }
  const navigate = useNavigate();

  const indexOfLastItem = Math.min(currentPage * selectedRow, data.length);
  const paginateValueWithLastItem = currentPage * selectedRow;

  let indexOfFirstItem = paginateValueWithLastItem - selectedRow;
  const lengthOfItems = itemsPerPage.length;
  const tableRef1 = useRef(null);
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedRow]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  useEffect(() => {
    setCurrentPage(1);
    setSortKey('');
    setSortOrder('asc');
  }, [data]);

  const handleSort = (key: string) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortKey(key);
      setSortOrder('asc');
    }
  };
  const getSortIndicator = (key: string) => {
    if (sortKey === key) {
      return sortOrder === 'asc' ? <BsArrowUp /> : <BsArrowDown />;
    }
    // return <BsArrowDown />;
    return null;
  };
 
 const handlePaginationChange = async (newPage: number, newItemsPerPage: number) => {
    // Your existing pagination logic
    const startIndex = (newPage - 1) * newItemsPerPage;
    const endIndex = startIndex + newItemsPerPage;
    const pageData = data.slice(startIndex, endIndex);
    
    // Call the callback if provided
    if (onPageChange) {
      await onPageChange(pageData, newPage, newItemsPerPage);
    }
    
    // Update the current page state
    setCurrentPage(newPage);
  };

 

  // const filteredData = data.filter((item) =>{
  //   const term = searchTerm.toLowerCase().split(' ');
  //   return term.some((term:any)=>item.facility_name && item.facility_name.toLowerCase().includes(term)||
  //   item.facility_type && item.facility_type.toLowerCase().includes(term)||
  //   item.hfr_id && item.hfr_id.toLowerCase().includes(term)||
  //   item.admin_body && item.admin_body.toLowerCase().includes(term)
  // )
  // }
  //   //


  // );
  const currentItems = data
    .sort((a, b) => {
      if(a && b && sortKey && sortOrder) {
        const aSortKey = a[sortKey] && a[sortKey].type === "component" ? a[sortKey].value: a[sortKey];
        const bSortKey = b[sortKey] && b[sortKey].type === "component" ? b[sortKey].value: b[sortKey];
          if (sortOrder === 'asc') {
            if(!aSortKey || aSortKey === null || aSortKey === '') return 1;
            if(!bSortKey || bSortKey === null || bSortKey === '') return -1;
            return aSortKey.localeCompare(bSortKey);
          } else if(sortOrder === 'desc') {
            if(!aSortKey || aSortKey === null || aSortKey === '') return -1;
            if(!bSortKey || bSortKey === null || bSortKey === '') return 1;
            return bSortKey.localeCompare(aSortKey);
          } else {
            return 0;
          }
      } else {
        return 0;
      }
    }).slice(indexOfFirstItem, paginateValueWithLastItem);


  const totalPages = Math.ceil(data.length / selectedRow);

  if(indexOfFirstItem < 0){
    indexOfFirstItem = 0
  }

  // const hanldeSelectedRow = (value: number) => {
  //   setSelectedRow(value)
  // }
  const handlePageChange = async (pageNumber: number) => {
    // setCurrentPage(pageNumber);
     await handlePaginationChange(pageNumber, selectedRow);
  };
  const renderPageItem = () => {
    const paginationItems = [];
    if (totalPages <= 4) {
      for (let number = 1; number <= totalPages; number++) {
        paginationItems.push(
          <Pagination.Item
            key={number}
            active={number === currentPage}
            onClick={() => handlePageChange(number)}
          >
            {number}
          </Pagination.Item>,
        );
      }
    } else {
      paginationItems.push(
        <Pagination.Item
          key={1}
          active={1 === currentPage}
          onClick={() => handlePageChange(1)}
        >
          {1}
        </Pagination.Item>,
      );

      if (currentPage > 3) {
        paginationItems.push(
          <Pagination.Ellipsis key="start-ellipsis" className="ellipse-dot" />,
        );
      }

      for (
        let number = Math.max(2, currentPage - 1);
        number <= Math.min(currentPage + 1, totalPages - 1);
        number++
      ) {
        paginationItems.push(
          <Pagination.Item
            key={number}
            active={number === currentPage}
            onClick={() => handlePageChange(number)}
          >
            {number}
          </Pagination.Item>,
        );
      }

      if (currentPage < totalPages - 2) {
        paginationItems.push(
          <Pagination.Ellipsis key="end-ellipsis" className="ellipse-dot" />,
        );
      }

      paginationItems.push(
        <Pagination.Item
          key={totalPages}
          active={totalPages === currentPage}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>,
      );
    }
    return paginationItems;
  };
  const renderTooltip = (text: any) => (
    <Tooltip id="tooltip-overflow" style={{position:"fixed"}}>{text}</Tooltip>
  );
  const shouldRTooltip = (text: any, maxLength = 20) => {
    return text?.length > maxLength;
  };

  const renderCell = (text: any) => {
    return shouldRTooltip(text) ? (
      <OverlayTrigger placement={toolTipPosition ? toolTipPosition : "bottom"} overlay={renderTooltip(text)}>
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: '80%', cursor: 'pointer' }}
        >
          {text}
        </span>
      </OverlayTrigger>
    ) : (
      <span> {text}</span>
    );
  };

  const goToZoneDetail = (zone: any) => {
    navigate(`${pathname}/view/${zone.id}`, {
      state: JSON.stringify(zone),
    });
  };

  const goToRoleDetail = (role: any) => {
    navigate(`${pathname}/view/${role.role_id}`, {
      state: JSON.stringify(role),
    });
  }

  const dispatch = useDispatch();
  let healthBlockById: any;
  let ulbByHealthBlockId: any;
  let ULB_ID: any;
  let blockByHealthBlockId: any;
  let BLOCK_ID: any;
  let subDistrictByHealthBlockId: any;
  let villagesByHealthBlockId: any;
  let getVilageByBlockId: any;
  let wardsByHealthBlockId: any;
  let getWardByUlbId: any;

  const fetchAPI = async (healthBlockData: any) => {
    const { id, mapped_village_count, mapped_wards_count } = healthBlockData;
    if (id) {
        try{
         healthBlockById = await axios.get(`${endpoints.getHealthBlockandSubDivByHBSDId(id)}`, Auth.loggedIn());
        }
       catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
        try{
         ulbByHealthBlockId = await axios.get(`${endpoints.getULBbyHbsdId(id)}`, Auth.loggedIn());
         ULB_ID = ulbByHealthBlockId.data.data[0].ulb_id;
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
        try{
           blockByHealthBlockId = await axios.get(`${endpoints.getblockHbsdId(id)}`, Auth.loggedIn());
           BLOCK_ID = blockByHealthBlockId.data.data[0].block_id;
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
       try{
         subDistrictByHealthBlockId = await axios.get(`${endpoints.getSubDistrictbyHbsdId(id)}`, Auth.loggedIn());
       }
       catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
        if (mapped_village_count) {
          try{
             villagesByHealthBlockId = await axios.get(`${endpoints.getVillagesByHBSDId(id)}`, Auth.loggedIn());
          }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
          try{
             getVilageByBlockId = await axios.get(`${endpoints.getVillageByBlockId(BLOCK_ID)}`, Auth.loggedIn());
          }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
          dispatch(setVillagesByBlockId(BLOCK_ID, getVilageByBlockId?.data?.data));
          dispatch(setVillageByHealthBlockId(id, villagesByHealthBlockId?.data?.data));
        }

        if (mapped_wards_count) {
          try{
             wardsByHealthBlockId = await axios.get(`${endpoints.getWardsByHBSDId(id)}`, Auth.loggedIn());
          }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
          try{
             getWardByUlbId = await axios.get(`${endpoints.getWard(ULB_ID)}`, Auth.loggedIn());
          }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
          dispatch(setWardsByUlbId(ULB_ID, getWardByUlbId?.data?.data))
          dispatch(setWardByHealthBlockId(id, wardsByHealthBlockId?.data?.data));
        }
        dispatch(setHealthBlockById(id, healthBlockById?.data?.data));
        dispatch(setULBByHealthBlockId(id, ulbByHealthBlockId?.data?.data));
        dispatch(setBlockByHealthBlockId(id, blockByHealthBlockId?.data?.data));
        dispatch(setSubDistrictByHealthBlockId(id, subDistrictByHealthBlockId?.data?.data));
        await fetchListById();

    }
  }

  const fetchListById = async () => {
    const STATE_ID = '42629363-b71b-4d32-86fa-167ecfe440e7';
    const DISTRICT_ID = '8a7d660c-8894-4680-b14c-e28132d2c15a';
    const subDistrictByDistrictId = await axios.get(`${endpoints.getSubDistricts(DISTRICT_ID)}`, Auth.loggedIn());
    const blockByDistrictId = await axios.get(`${endpoints.getBlock(DISTRICT_ID)}`, Auth.loggedIn());
    const ulbByStateId = await axios.get(`${endpoints.getUlb(STATE_ID)}`, Auth.loggedIn());
    dispatch(setSubDistrictByDistrict(DISTRICT_ID, subDistrictByDistrictId.data.data));
    dispatch(setBlockByDistrict(DISTRICT_ID, blockByDistrictId.data.data));
    dispatch(setUlbByState(STATE_ID, ulbByStateId.data.data));

  }

  const goToHealthBlockDetail = async (healthBlockData: any) => {
    await fetchAPI(healthBlockData);
    navigate(`${pathname}/view/${healthBlockData.id}`, {
      state: JSON.stringify(healthBlockData),
    });
  };

  const fetchDistrictData = async (zoneId:any) => {
    try {
      const response = await axios.get(`${endpoints.getDistrictsByZDCId(zoneId.id)}`, Auth.loggedIn());
      const districtData = response.data.data;
      // Update the state with the fetched district data
    } catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  };

  const getCurrentRow =(currentPage:number,index:number)=>{
    if(currentPage ==1){
      return currentPage*index;
    }
    else{
      return (currentPage-1)*10+index;
    }
   
  }
  
  // const columnHeaders = data.length > 0 ? Object.keys(data[0]) : [];
  return (
    <>
      {data && data.length > 0 ? (
        <div className="datatable-container" style={{ height: height }}>
          {mappedModal &&
            <div>
              <MappedModal title={MAPPED_VALUE[mappedOf]} 
                show={mappedModal}
                setShowMappedModel={setShowMappedModel}
                id={data[currentColumn].id}
              />
            </div>}

          <Table className="table-cl" responsive ref={tableRef1}>
            <thead>
              <tr>
                {columnHeader.map((header, index) => (
                  <th
                    key={index}
                    onClick={() => header.sortable && handleSort(header.key)}
                    className={`header ${header.name}`}
                    style={{
                      cursor: 'pointer',
                      width: header.width ? `${header.width}px` : 'auto',
                      display:header.gridView?'none':'',
                      textAlign:'center',
                      whiteSpace: 'nowrap',
                      verticalAlign: 'middle',
                    }}
                  >
                    {header.name}
                    {getSortIndicator(header.key) && (
                      <span>{getSortIndicator(header.key)}</span>
                    )}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentItems && currentItems.map((item, dataIndex) => (
                <tr key={dataIndex} data-rowno={getCurrentRow(currentPage,dataIndex)} >
                  {columnHeader && columnHeader?.map((header, index) => {
                    const value = item[header?.key];
                    return (
                      <td
                        key={index}
                        className={(header.name === "Name" && gridFor === 'user') || (header.name === "User Role" && gridFor === 'role') ? 'first-cell' : index === 1 && gridFor === 'healthFacility' ? 'first-cell' : index === 0 && gridFor === 'Beneficiary'? 'first-cell':index === 1 && gridFor === 'Approval'? 'first-cell' : 'cell'}
                        style={{
                          maxWidth: header.width ? `${header.width}px` : '100%', overflow: 'hidden',
                          textOverflow: header?.allowWrap ? 'clip' : 'ellipsis',
                          whiteSpace: header?.allowWrap ? 'normal' : 'nowrap',
                          wordBreak: header?.allowWrap ? 'break-word' : 'normal',
                          cursor: header?.showDetails ? 'pointer' : 'default',
                          display:header.gridView?'none':''
                        }}
                        onClick={header?.showDetails ? (e) => {
                          if ((header?.showDetails === 'mapped_district_count' && value!==0) ||
                            header?.showDetails === 'mapped_village_count' ||
                            header?.showDetails === 'mapped_gram_panchayat_count' ||
                            header?.showDetails === 'mapped_wards_count'
                          ) {
                            setMappedOf(header?.showDetails);
                            const rowNo = Number(e?.currentTarget?.parentElement?.dataset.rowno);
                            setCurrentColumn(rowNo);
                            if(item[header?.showDetails]!==0){
                              setShowMappedModel(true);
                            }
                           
                            fetchDistrictData (data[currentColumn]);
                          } else if (header?.showDetails === 'health_name_block') {
                            const rowNo = Number(e?.currentTarget?.parentElement?.dataset.rowno);
                            setCurrentColumn(rowNo);
                            goToHealthBlockDetail(data[rowNo])
                          } else if(header?.showDetails === 'mapped_district_count' && value===0){
                            const rowNo = Number(e?.currentTarget?.parentElement?.dataset.rowno);
                            setCurrentColumn(rowNo);
                          }
                          else if(header?.showDetails === 'role_name'){
                            const rowNo = Number(e?.currentTarget?.parentElement?.dataset.rowno);
                            setCurrentColumn(rowNo);
                            goToRoleDetail(data[rowNo]);
                          }
                          else {
                            const rowNo = Number(e?.currentTarget?.parentElement?.dataset.rowno);
                            setCurrentColumn(rowNo);
                            goToZoneDetail(data[rowNo])
                          }

                        } : undefined}
                      >
                        <span className="text-truncate"
                          style={{
                            whiteSpace: header?.allowWrap ? 'pre-line' : 'nowrap',
                            display: 'inline-block',
                            maxWidth: '100%',
                            ...(header?.contentStyle || {})
                          }}
                        >
                          {
                            header?.type == 'select_box' ? (
                              <CheckboxComponent
                                className={''}
                                isChecked={selectedRows?.find((el: any) => el == value)}
                                disabled={false}
                                onCheckboxChange={(e: any) => {
                                  typeof handleCheckboxChange == 'function' && handleCheckboxChange(
                                    item,
                                    e,
                                  )
                                }}
                            />
                            )
                          : value !== null && value !== undefined && value.type === 'component' ? (
                            <value.component user={item} index={dataIndex} />
                          ) : (
                            header?.allowWrap ? <span>{value}</span> : renderCell(value)
                          )}
                        </span>
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </Table>
          {pagination && (
            <div className="pagination-container">
              <div>
                <p className='records_page_count'>{indexOfFirstItem + 1}-{indexOfLastItem} of  {data.length}</p>
              </div>
              <div>
                <Pagination>
                  <Pagination.Prev
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <LeftPageIcon />
                  </Pagination.Prev>
                  {renderPageItem()}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <RightPageIcon />
                  </Pagination.Next>
                </Pagination>
              </div>
              <div className='rows_per_page_dropdown'>
                <RowsPerPageDropdown label={'Results per Page:'} options={itemsPerPage} onSelect={handleSelectedRow} />
              </div>
            </div>
            
          )}
        </div>
      ) : (
        <div className="datatable-container">{'No Records Found'}</div>
      )}

    </>
  );
};
export default DataTable;